// extracted by mini-css-extract-plugin
export var hideEditor = "_kd-2";
export var infoIcon = "_kd-3";
export var label = "_kd-1";
export var labelContainer = "_kd-0";
export var readonlyText = "_kd-4";